<template>
    <a-layout-header :style="{zIndex: 85,width: '100%',height:'50px',padding:'0'}">
        <a-row type="flex" :style="{width:rightWidth+'px'}" justify="space-between">
            <a-col :span="8" :style="{paddingLeft:'0px'}">
                <a-icon
                    class="trigger"
                    :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                    @click="GoMenu"
                    :style="{width:'40px',height:'40px;',fontSize:'30px',margin:'10px 0 10px 20px'}"
                />
            </a-col>
            <a-col :span="8" :style="{paddingRight:'20px',textAlign:'right',lineHeight:'50px',}">
                <a-dropdown>
                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                        <a-avatar shape="square" :size="40" icon="user" />
                    </a>
                    <a-menu slot="overlay">
                        <a-menu-item>
                            <a-button type="link"><router-link to="/ChangePassword">修改密码</router-link></a-button>
                        </a-menu-item>
                        <a-menu-divider />
                        <a-menu-item>
                            <a-button type="link" @click="LogOut">退出登录</a-button>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </a-col>
        </a-row>
    </a-layout-header>
</template>

<script>
import Cookies from "js-cookie";
export default {
    name: "header_bar",
    data(){
        return{
            fullWidth:document.body.clientWidth,
            rightWidth:0,
        }
    },
    beforeMount() {
        //console.log(this.collapsed)
    },
    created(){
        window.addEventListener('resize', this.handleResize())
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.handleResize())
    },
    computed:{
        collapsed(){
            return this.$store.state.collapsed
        }
    },
    mounted(){
        this.getRightWidth();
        window.onresize = () => {
            return (() => {
                this.fullWidth = document.body.clientWidth;
                this.getRightWidth();
            })();
        };
    },
    methods:{
        getRightWidth(){
            let leftWidth = this.collapsed ? '80' : '240';
            this.rightWidth = this.fullWidth*1 - leftWidth*1;
            // console.log(document.documentElement.clientWidth);
            // console.log(document.body.scrollWidth);
            //console.log(document.getElementById("header").offsetWidth);
        },
        GoMenu(){
            if(this.collapsed === true){
                this.$store.commit("GoMenu", false)
                this.rightWidth = this.fullWidth*1 - 240*1;
            }else if(this.collapsed === false){
                this.$store.commit("GoMenu", true)
                this.rightWidth = this.fullWidth*1 - 80*1;
            }
        },
        LogOut(){
            Cookies.remove('Token');
            this.$router.push({path:'/login'})
        },
        handleResize () {
            this.fullWidth = document.body.clientWidth
        },

    }

}
</script>

<style scoped>
#components-main-layout .ant-layout-header{
    background: rgb(60, 141, 188);
    color: #fff;
}
.clearfix{clear:both;}
</style>